import List from './list/ReferralPriorityListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})